export default __webpack_public_path__ + "static/media/clo_afterLogin.bf80673a.jpg";